let leafletCssPromise: Promise<void> | null = null

/** Load Leaflet CSS on demand so homepage SSR does not link it. */
export function loadLeafletCss(): Promise<void> {
  if (typeof document === 'undefined') return Promise.resolve()
  if (leafletCssPromise) return leafletCssPromise

  leafletCssPromise = import('leaflet/dist/leaflet.css').then(() => undefined)
  return leafletCssPromise
}
